import React from "react";
import MixAndMatchAboveContainerView from "./MixAndMatchAboveContainerView";
import ProductListing from "../ProductListing";
import { MixAndMatchPageResult } from "./MixAndMatchPageResult";
import FeatureFlagProvider from "~/common/contexts/FeatureFlagProvider";

const MixNMatchPage = ({
  featureFlags,
  facetNavigation,
  pageHeader,
  pageUrl,
  pagination,
  products,
  subHeadings,
}: MixAndMatchPageResult) =>
  products?.length ? (
    <FeatureFlagProvider featureFlags={featureFlags}>
      <ProductListing
        aboveChromeComponent={
          <MixAndMatchAboveContainerView
            pageHeader={pageHeader}
            subHeadings={subHeadings}
          />
        }
        facetNavigation={facetNavigation}
        hasBackground={false}
        hasHeaderData={false}
        hideFilters={false}
        hideTopper
        pageName="MixNMatch"
        pageUrl={pageUrl}
        pagination={pagination}
        products={products}
        showCategoryFilter={false}
        showPartsFilter={false}
      />
    </FeatureFlagProvider>
  ) : (
    <h1 className="page-header">No Results Found</h1>
  );

export default MixNMatchPage;
